// Trang mặc định sau khi đăng nhập / chọn workspace — CHỈ CỦA CNV CONNECT.
//
// Sếp Phú chốt 27/08/2026: **/chat (Chat nội bộ)** là nơi đáp. Trước đó lần lượt là /chat →
// /dashboard (TC-292) → /tasks (khi ẩn Tổng quan cùng ngày) — mỗi lần đổi lại phải sửa 4 chỗ
// rời nhau và có lần sót (WorkspaceSelectorPage kẹt ở '/inbox' suốt từ 13/08, module đã gỡ,
// nên mọi lượt chọn workspace đều âm thầm dội về /dashboard). Nay 4 chỗ đó gọi CHUNG hàm này.
//
// ⛔ KHÔNG bê hàm này sang cnv-ui: Core + Work SaaS có nơi đáp riêng, đây là quyết định sản
// phẩm của riêng cụm Connect.
//
// Vì sao vẫn phải có nhánh dự phòng: tenant TẮT module team_chat mà ép vào /chat thì ăn màn
// lỗi "Module team_chat chưa enable" ngay khi vừa đăng nhập (đúng sự cố TC-292 / ticket
// 46d0d32b). Cờ đọc từ `activeTenant.private_modules` — authStore persist xuống localStorage
// nên có sẵn ngay lần render đầu, không phải chờ /auth/me.

/** Nơi đáp khi tenant có Chat nội bộ. */
export const HOME_WITH_TEAM_CHAT = '/chat';

/** Nơi đáp dự phòng khi tenant tắt Chat nội bộ. KHÔNG dùng /dashboard: Tổng quan đã ẩn khỏi
 *  menu 27/08/2026, chỉ còn sống làm lưới an toàn cho guard quyền. */
export const HOME_FALLBACK = '/tasks';

/**
 * @param {{ private_modules?: Record<string, boolean> }|null|undefined} tenant activeTenant
 *        trong authStore, hoặc `active_tenant` mà /auth/login + /auth/switch-tenant trả về.
 */
export function homeRouteFor(tenant) {
  return tenant?.private_modules?.team_chat ? HOME_WITH_TEAM_CHAT : HOME_FALLBACK;
}
